"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const date_filter_default_value_types_1 = require("../model/date-filter-default-value-types");
/**
 * For MeasureDate filter we have to keep dateType for 'ON_OR_AFTER' && 'ON_OR_BEFORE' default values,
 * for other types changes brings selected type to 'Custom' type, what incompatible with 'ON_OR_AFTER' && 'ON_OR_BEFORE'
 * @param state
 */
function processMeasureDateFilterResetState(state) {
    let resetState = Object.assign({}, state, { valueFrom: null, valueTo: null });
    if (state && state.dateType && state.dateType !== date_filter_default_value_types_1.DateFilterDefaultValueTypes.ON_OR_AFTER &&
        state.dateType !== date_filter_default_value_types_1.DateFilterDefaultValueTypes.ON_OR_BEFORE) {
        resetState.dateType = null;
    }
    return resetState;
}
exports.processMeasureDateFilterResetState = processMeasureDateFilterResetState;
//# sourceMappingURL=page-date-filter-helper.js.map